import React, { FC } from 'react';
import styles from './FlatOptions.module.css';

export class FlatOption {
    title: string;
    value: any;
}

interface FlatOptions {
    label: string,
    options: FlatOption[],
    activeOption: any,
    setActiveOptionValue: (a) => void
}

const FlatOptions: FC<FlatOptions> = ({ label, options, activeOption, setActiveOptionValue }) => {
    return (
        <div className={styles.FlatOptions} data-testid="FlatOptions">
            <div className={`${styles.flatLabel}`}>
                <label>{label}</label>
            </div>
            <div className={styles.flex}>
                {
                    options.map((option, index) =>
                        <button className={`${styles.option} ${activeOption === option.value ? styles.active : ''}`} key={index} onClick={() => setActiveOptionValue(({target: {value: option.value}}))}><div>{option.title}</div></button>
                    )
                }
            </div>
        </div>
    )
};

export default FlatOptions;
